<template>
    <div>
        <b-card no-body>
            <b-alert variant="secondary" show style="display: inline-block; vertical-align: top;">
                <div style="display: inline-block; vertical-align: top;">
                    <div>DATES</div>
                    <date-picker
                    v-model="date_range"
                    format="MM-DD-YYYY"
                    valueType="format"
                    style="width: 220px; font-size: 15px; display: block;"
                    placeholder="DATE OR DATE RANGE"
                    range
                    ></date-picker>
                </div>

                <div style="display: inline-block; vertical-align: top;">
                     <div>&nbsp;</div>
                    <b-button variant="success" style="display: inline-block; padding: 4px;" @click="fetch_init">SEARCH</b-button>
                </div>


                <div style="display: inline-block;" v-if="(packet.userDetails.userrole == 'admin' || packet.userDetails.userrole == 'locationadmin') && (items.length > 0) ">
                    <div>SALESPERSON</div>
                    <b-form-select :options="users" v-model="picked_user" style="width: 200px;" v-on:change="process_data_for_plot"></b-form-select>
                </div>

                <div style="display: inline-block;" v-if="(packet.userDetails.userrole == 'admin') && (items.length > 0) ">
                    <div>SALE LOCATION</div>
                    <b-form-select :options="packet.locations" v-model="picked_location" style="width: 200px;" v-on:change="process_data_for_plot"></b-form-select>
                </div>

                <div style="display: inline-block;" v-if="(items.length > 0) ">
                    <div>SALE TYPE</div>
                    <b-form-select :options="sale_types" v-model="sale_type" style="width: 200px;" v-on:change="process_data_for_plot"></b-form-select>
                </div>

                <div style="display: inline-block; margin: 10px; width: auto; background: none; padding: 3px; border: 0px dashed black; font-size: 12px; color: black;" v-if="items.length >0 && ['admin', 'locationadmin', 'locationmanager', 'warehousemanager', 'officeuser', 'officemanager'].includes(packet.userDetails.userrole)">
                    <div>&nbsp;</div>
                    <download-csv
                        class   = "btn"
                        :data   = "get_csv_data()"
                        style = "border: 1px solid black; width: 180px; background: black; color: white; "
                        :name    = "get_csv_filename()">

                        DOWNLOAD EXCEL

                    </download-csv>
                </div>
            </b-alert>

            <b-card-text style="padding-left: 15px; gap: 5px;" class="d-flex flex-wrap">
                <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='today'" @click="set_dates('today')">Today</b-button>
                <b-button size="sm" variant="outline-danger"  :pressed="picked_date_range=='yesterday'" @click="set_dates('yesterday')">Yesterday</b-button>
                <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='this_week'" @click="set_dates('this_week')">This Week</b-button>
                <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='last_week'" @click="set_dates('last_week')">Last Week</b-button>
                <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='this_month'" @click="set_dates('this_month')">This Month</b-button>
                <b-button size="sm" variant="outline-danger"  :pressed="picked_date_range=='last_month'" @click="set_dates('last_month')">Last Month</b-button>
            </b-card-text>

            <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                <div v-if="items.length > 0" style="margin-top: 10px; overflow: scroll;" class="mx-2 mx-md-0 mb-2">
                   <table class="text-monospace" style="width: 100%;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <th class="ipt_tdhr" style="min-width: 120px; width: 170px;" @click="sortby('ts')">
                                    DATE
                                </th>
                                <th class="ipt_tdhr" style="min-width: 180px;" @click="sortby('locsub')">
                                    SOLD FROM
                                </th>
                                <th class="ipt_tdhr" style="min-width: 100px;" @click="sortby('invoice_id')">
                                    INV #
                                </th>
                                <th class="ipt_tdhr" style="min-width: 100px;" @click="sortby('username')">
                                    SOLD BY
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;" @click="sortby('sale_type')">
                                    SALE TYPE
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;" @click="sortby('total')">
                                    TOTAL
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;" @click="sortby('sales_tax')">
                                    SLS TAX
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;" @click="sortby('delivery_charges')">
                                    DLVRY
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;" @click="sortby('setup_charges')">
                                    SETUP
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;" @click="sortby('warranty_charges')">
                                    WARRANTY
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;" @click="sortby('cash_payments')">
                                    CASH
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;" @click="sortby('cc_payments')">
                                    CC
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;" @click="sortby('store_credit_payments')">
                                    STORE CREDIT
                                </th>
                                <th class="ipt_tdhr" style="min-width: 50px;" @click="sortby('finance_payments')">
                                    FINANCE
                                </th>
                                <th class="ipt_tdhr" style="min-width: 5px;" @click="sortby('tax_exempt_payments')">
                                    TAX EXEMPT
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr style="background: lightyellow;">
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header"></td>
                                <td class="ipt_tdhr header">
                                    <b>{{ total('total').toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ total('sales_tax').toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ (total('delivery_charges')).toFixed(2)  }}</b>
                                </td>
                                <td class="ipt_tdhr header" v-if="packet.userDetails.userrole == 'admin'">
                                    <b>{{ total('setup_charges').toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header" v-if="packet.userDetails.userrole == 'admin'">
                                    <b>{{ total('warranty_charges').toFixed(2) }}</b>
                                </td>
                                <td class="ipt_tdhr header">
                                    {{ total('cash_payments').toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr header">
                                    {{ total('cc_payments').toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr header">
                                    {{ ( total('store_credit_payments')  || 0.0).toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr header">
                                    {{ ( total('finance_payments')  || 0.0).toFixed(2) }}
                                </td>
                                <td class="ipt_tdhr header">
                                    {{ ( total('tax_exempt_payments')  || 0.0).toFixed(2) }}
                                </td>
                            </tr>
                        </tbody>

                        <tbody>
                            <tr v-for="item,idx in filter" v-bind:key="idx"  :style="{background: ((item.is_refund_entry == true) ? '#ffab91':'white')}">
                                <td class="ipt_tdhr non-header">
                                    {{item.ts}}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{packet.locsubsdict[item.locsub]}}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{item.invoice_id}}
                                </td>
                                <td class="ipt_tdhr" @click="sortby('username')">
                                {{item.username}}
                                </td>
                                <td class="ipt_tdhr" @click="sortby('username')">
                                {{item.sale_type}}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.total }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.sales_tax }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.delivery_charges }}
                                </td>
                                <td class="ipt_tdhr non-header" v-if="packet.userDetails.userrole == 'admin'">
                                    {{ item.setup_charges }}
                                </td>
                                <td class="ipt_tdhr non-header" v-if="packet.userDetails.userrole == 'admin'">
                                    {{ item.warranty_charges }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.cash_payments }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.cc_payments }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.store_credit_payments }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.finance_payments }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.tax_exempt_payments }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <b-alert show variant="warning">No records</b-alert>
                </div>
            </b-overlay>
        </b-card>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    import moment from 'moment';
    import global_vars from '@/utilities/global_vars';
    import Backer from '@/components/globals/Backer';
    import Requestor from '@/utilities/Requestor';
    import LineChartV1 from "@/components/importables/LineChartV1"

    export default {
        name: "SalesPaymentMethods",
        components: {Backer, DatePicker, LineChartV1},
        data: function(){
            return {
                packet: {},
                items: [],
                items_being_loaded: false,
                global_vars: global_vars,
                date_range: [],
                picked_date_range: null,
                sort_asc: false,
                sales_types: [
                    {"value": null, "text": "All"},
                    {"value": "delivered", "text": "Delivered Only"},
                    {"value": "written", "text": "Written Only"},
                ],
                sales_type: null,
                users: [],
                usersdict: {},
                picked_user: null,
                picked_location: null,
                report_chart_1_data: {},
                resport_chart_1_config: {},
                sale_types: [
                    {value: "regular", text: "REGULAR"},
                    {value: "layaway", text: "LAYAWAY"}
                ],
                sale_type: "regular",
            }
        },
        computed: {
            filter: function(){
                let that = this;

                return this.items.filter(function(d){
                    //console.log(d.data.final_eta, that.date_range)
                    return (
                        ((that.picked_user) ? d.username == that.picked_user : true )
                        &&
                        ((that.picked_location) ? d.location_id == that.picked_location : true )
                        &&
                        ((that.sale_type) ? d.sale_type == that.sale_type : true )

                    )
                })
            }
        },
        methods: {
            allowed: function(item) {
                let status = true;






                if (this.picked_user == null && this.picked_location == null){
                    status = true
                }

                if (this.picked_user != null && this.picked_location == null){
                    if (item.username == this.picked_user){
                        status = true
                    }
                    else {
                        status = false
                    }
                }

                if (this.picked_user == null && this.picked_location != null){
                    if (item.location_id == this.picked_location){
                        status = true
                    }
                    else {
                        status = false
                    }
                }

                if (this.picked_user != null && this.picked_location != null){
                    if (item.location_id == this.picked_location){
                        if (item.username == this.picked_user){
                            status = true
                        }
                        else {
                            status = false
                        }
                    }
                    else {
                        status = false
                    }
                }
                return status
            },
            total: function(key){
                let that = this;
                let out = this.filter.filter(function(d){return that.allowed(d) == true});
                let total_val = 0.0;
                for (var i=0; i<out.length; i++){
                    total_val += ( parseFloat(out[i][key]) || 0.0);
                }
                return total_val
            },
            set_dates: function(value){
                let start = null;
                let end = null;

                if(value == 'today') {
                    start = moment().format("MM-DD-YYYY");
                    end = moment().format("MM-DD-YYYY");

                }
                if(value == 'yesterday') {
                    start = moment().add(-1, 'days').format("MM-DD-YYYY");
                    end = moment().add(-1, 'days').format("MM-DD-YYYY");
                }
                if(value == 'this_week') {
                    start = moment().startOf('week').format("MM-DD-YYYY");
                    end = moment().endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'last_week') {
                    start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'this_month') {
                    start = moment().startOf('month').format("MM-DD-YYYY");
                    end = moment().endOf('month').format("MM-DD-YYYY");
                }
                if(value == 'last_month') {
                    start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY");
                }



                if (start && end) {
                    this.date_range = [start , end]
                    this.picked_date_range = value;

                    this.fetch_init()
                }
            },
            fetch_init: function(){
                let dates = this.date_range;
                let that = this;
                let data = {dates: dates, location_id: (this.packet.userDetails.properties.location_id || null)}
                console.log(data)
                let path = "/api/sales/get_sales_distributed_pms/"
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                        console.log(that.items)
                        //that.process_data_for_plot();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                this.items = [];
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetch_users_list: function(){
                let data = {userrole: this.packet.userDetails.userrole, user_id: this.packet.userDetails.id};
                // if (location_id){
                //     data.location_id = location_id;
                // }
                let that = this;
                let path = "/api/user/get_my_users_list/"
                let s = function(response) {
                    if (response.data.result){
                        that.users = response.data.result;

                        for (var i=0; i<that.users.length; i++){
                            that.usersdict[that.users[i].value] = true;
                        }

                        that.users.splice(0, 0, {value: null, text: "ALL"});
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    //that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    //that.items_being_loaded = false
                }
                //this.items_being_loaded = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            },
            process_data_for_plot: function(){
                let that = this;
                this.report_chart_1_data = {};
                this.report_chart_1_config = {};
                let items = this.items.filter(function(d){return that.allowed(d)}).map(function(d){d.date = d.ts.split(" ")[0]; return d;});
                let outdict = {};
                for (var i=0; i<items.length; i++){
                    let it = items[i];
                    let date = it.date;
                    if (!outdict[date]){
                        outdict[date] = (it.total_dollar_amount || 0.0);
                    }
                    else {
                        outdict[date] += (it.total_dollar_amount || 0.0);
                    }
                }
                let labels = Object.keys(outdict);
                let vals = Object.values(outdict);
                this.report_chart_1_data = {
                    labels: labels,
                    datasets: [{data: vals, label: "TOTAL SALE", fill: true, tension: 0.1, borderColor: "#dc3545"}],
                };
                this.report_chart_1_config = {type: 'line'};
            },
            filter_function: function(){
                let that = this;

                return this.items.filter(function(d){
                    //console.log(d.data.final_eta, that.date_range)
                    return (
                        ((that.picked_user) ? d.username == that.picked_user : true )
                        &&
                        ((that.picked_location) ? d.location_id == that.picked_location : true )
                        &&
                        ((that.sale_type) ? d.sale_type == that.sale_type : true )

                    )
                })
            },
            get_csv_data: function(){
                let data = [];
                let items = this.filter_function()
                for (var i = 0; i<items.length; i++){
                    let each = items[i];

                    data.push(
                    {
                        "DATE": each.ts,
                        "INVOICE_ID": each.invoice_id,
                        "SOLD_FROM": this.packet.locsubsdict[each.locsub],
                        "USERNAME": each.username,
                        "SALETYPE": each.sale_type,
                        "TOTAL": each.total,
                        "SALES_TAX": each.sales_tax,
                        "DELIVERY": each.delivery_charges,
                        "SETUP": each.setup_charges,
                        "WARRANTY": each.warranty_charges,
                        "CASH": each.cash_payments,
                        "CC": each.cc_payments,
                        "STORE_CREDIT": each.store_credit_payments,
                        "FINANCE": each.finance_payments
                    }
                    )
                }
                return data
            },
            get_csv_filename: function(){
                let now = moment().format("YYYY-MM-DD_HHmmss")
                return `SALES_PAYMENTS_${now}.csv`
            },
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);

            if (this.packet.userDetails.userrole == "admin" || this.packet.userDetails.userrole == "locationadmin"){
                this.fetch_users_list();
            }
        }
    }
</script>

<style scoped>
    .header {
        font-size: 12px;
    }
    .non-header {
        font-weight: normal;
        font-size: 11px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Sales/SalesPaymentMethods.vue